import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_STATEMENT_GROUPS',
    icon: 'MoreVerticalIcon',
    route: 'statement-groups',
    companyOnly: true,
    action: constants.action.permissionStatementGroupView,
    resource: constants.resource.statementGroups,
  },
]
